"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = save;

var _element = require("@wordpress/element");

var _blockEditor = require("@wordpress/block-editor");

/**
 * WordPress dependencies
 */
function save(_ref) {
  let {
    attributes: {
      height,
      width
    }
  } = _ref;
  return (0, _element.createElement)("div", _blockEditor.useBlockProps.save({
    style: {
      height,
      width
    },
    'aria-hidden': true
  }));
}
//# sourceMappingURL=save.js.map